import React from "react";
import JSONLD from "./json-ld";
export default function JSONLDOrganization(_ref) {
  var url = _ref.url;
  var organizationJsonLD = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: "Lyst",
    url: url,
    sameAs: ["https://twitter.com/lyst", "https://www.facebook.com/Lyst", "https://instagram.com/lyst/", "https://plus.google.com/+LYST", "https://www.pinterest.com/Lyst/", "http://lyst.tumblr.com/"]
  };
  return React.createElement(JSONLD, {
    JSONLD: organizationJsonLD
  });
}